//import Main from '@/views/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录 - X-Boot前后端分离开发平台 '
    },
    component: () => import('@/views/login.vue')
};

export const registRouter = {
    path: '/regist',
    name: 'regist',
    meta: {
        title: '注册 - X-Boot前后端分离开发平台'
    },
    component: () => import('@/views/regist.vue')
};

export const registResult = {
    path: '/regist-result',
    name: 'regist-result',
    meta: {
        title: '注册结果 - X-Boot前后端分离开发平台'
    },
    component: () => import('@/views/regist-result.vue')
};

export const thirdLogin = {
    path: '/thirdLogin/:id',
    name: 'thirdLogin',
    meta: {
        title: '第三方登录 - X-Boot前后端分离开发平台 '
    },
    component: () => import('@/views/thirdLogin.vue')
};
// export const page404 = {
//     path: '/*',
//     name: 'error-404',
//     meta: {
//         title: '404-页面不存在'
//     },
//     component: () => import('@/views/error-page/404.vue')
// };

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: () => import('@/views/error-page/403.vue')
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () => import('@/views/error-page/500.vue')
};

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('@/views/main-components/lockscreen/components/locking-page.vue')
};

// 剩余次数页面
export const lookMember = {
    path: '/look-member',
    name: 'lookMember',
    component: () => import('@/views/vipClip/user/personal/lookMember.vue')
}
//咨询列表
export const consultationList = {
    path: '/consultation-list',
    name: 'consultationList',
    component: () => import('@/views/vipClip/consultation/consultation-list.vue')
};
//咨询详情
export const consultationInfo = {
    path: '/consultation-info/:id',
    name: 'consultationInfo',
    component: () => import('@/views/vipClip/consultation/consultation-info.vue')
};
export const searchQuestion = {
    path: '/search-question',
    name: 'searchQuestion',
    component: () => import('@/views/vipClip/search-question/search-question.vue')
};
// 版权存证
export const applyCert = {
    path: '/apply-cert',
    name: 'applyCert',
    component: () => import('@/views/vipClip/copyrightEvidence/apply-cert.vue')
}
//存证列表
export const certList = {
    path: '/cert-list',
    name: 'certList',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-list.vue')
};
//存证详情
export const certInfo = {
    path: '/cert-info',
    name: 'certInfo',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-info.vue')
};
//存证介绍
export const copyrightEvidence = {
    path: '/copyrightEvidence',
    name: 'copyrightEvidence',
    component: () => import('@/views/vipClip/copyrightEvidence/copyrightEvidence.vue')
};
//取证列表
export const evidenceList = {
    path: '/evidence-list',
    name: 'evidenceList',
    component: () => import('@/views/vipClip/evidence/evidence-list.vue')
};
//取证详情
export const evidenceInfo = {
    path: '/evidence-info',
    name: 'evidenceInfo',
    component: () => import('@/views/vipClip/evidence/evidence-info.vue')
};
//取证介绍
export const evidence = {
    path: '/evidence',
    name: 'evidence',
    component: () => import('@/views/vipClip/evidence/evidence.vue')
};
//取证网页
export const evidenceWeb = {
    path: '/evidenceWeb',
    name: 'evidenceWeb',
    component: () => import('@/views/vipClip/evidence/evidence-web.vue')
};
//版权监测
export const monitor = {
    path: '/monitor',
    name: 'monitor',
    component: () => import('@/views/vipClip/monitor/monitor')
};
//版权监测介绍
export const monitorIntroduce = {
    path: '/monitorIntroduce',
    name: 'monitorIntroduce',
    component: () => import('@/views/vipClip/monitor/monitor-introduce.vue')
};
//版权监测监测中
export const monitoring = {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('@/views/vipClip/monitor/monitoring.vue')
};
//版权监测监测详情
export const monitorDetails = {
    path: '/monitorDetails',
    name: 'monitorDetails',
    component: () => import('@/views/vipClip/monitor/monitorDetails.vue')
};

//关于我们
export const aboutUs = {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/vipClip/search-question/aboutUs.vue')
};

//版权登记
export const copyrightRegistration = {
    path:'/copyrightRegistration',
    name:'copyrightRegistration',
    component: ()=> import('@/views/vipClip/copyrightRegistration/copyrightRegistration.vue')
};

//版权登记列表
export const copyrightRegList = {
    path:'/copyrightRegList',
    name:'copyrightRegList',
    component: ()=> import('@/views/vipClip/copyrightRegistration/copyrightRegList.vue')
};

//版权登记证书
export const copyrightCert = {
    path:'/copyrightCert',
    name:'copyrightCert',
    component: ()=> import('@/views/vipClip/copyrightRegistration/copyrightCert.vue')
};

//版权登记详情
export const copyrightDetails = {
    path:'/copyrightDetails',
    name:'copyrightDetails',
    component: ()=> import('@/views/vipClip/copyrightRegistration/copyrightDetails.vue')
};

//预登记详情
export const preDetails = {
    path:'/preDetails',
    name:'preDetails',
    component: ()=> import('@/views/vipClip/pre/preDetails.vue')
};

//版权登记提交成功
export const copyrightSuccess = {
    path:'/copyrightSuccess',
    name:'copyrightSuccess',
    component: ()=> import('@/views/vipClip/copyrightRegistration/copyrightSuccess.vue')
};
//原创核验
export const contentListOriginal = {
    path: '/index/original_verification/:type/:id',
    name: 'contentListOriginal',
    component: () => import('@/views/vipClip/verificationOriginal/contentListOriginal.vue')
};
//核验
export const creationVerification = {
    path: '/index/creation_verification/:type/:id',
    name: 'creationVerification',
    component: () => import('@/views/vipClip/verification/contentList.vue')
};
//核验-1200px核验码校验
export const verificationCode = {
    path: '/index/verification_code/:type/:id',
    name: 'verificationCode',
    component: () => import('@/views/vipClip/verification/verificationCode.vue')
};
//统一核验页面
export const verificationPublic = {
    path: '/index/common_verification/:type/:id',
    name: 'verificationPublic',
    component: () => import('@/views/vipClip/verification/verificationPublic.vue')
};
//存证核验中转页面
export const certVerify = {
    path: '/index/exchange/detail/:type/:id',
    name: 'certVerify',
    component: () => import('@/views/vipClip/copyrightEvidence/cert-verify.vue')
};

//DCI介绍页
export const dciIntroduce = {
    path: '/dciIntroduce',
    name: 'dciIntroduce',
    component: () => import('@/views/vipClip/firstPage/dciPage.vue')
};

//存证登记
export const groupIntroduce = {
    path: '/groupIntroduce',
    name: 'groupIntroduce',
    component: () => import('@/views/vipClip/dci/groupIntroduce.vue')
};

//邀请好友中转页
export const invitePage = {
    path: '/invitePage',
    name: 'invitePage',
    component: () => import('@/views/vipClip/user/more/invitePage.vue')
};

// 首页vip的静态页面
export const vipOne = {path: '/vipPersonal', name: 'vipone', component: () => import('@/views/vipClip/vip/vipone.vue')};
export const vipTwo = {path: '/vipEnterprise', name: 'viptwo', component: () => import('@/views/vipClip/vip/viptwo.vue')};
export const vipSeven = {
    path: '/vipseven',
    name: 'vipseven',
    component: () => import('@/views/vipClip/vip/vipseven.vue')
};
export const regEvidence = {
    path: '/regEvidence',
    name: 'regEvidence',
    component: () => import('@/views/vipClip/vip/regEvidence.vue')
};
export const lawContract = {
    path: '/lawContract',
    name: 'lawContract',
    component: () => import('@/views/vipClip/vip/lawContract.vue')
};
export const lawInfringing = {
    path: '/lawInfringing',
    name: 'lawInfringing',
    component: () => import('@/views/vipClip/vip/lawInfringing.vue')
};
export const lawIssue = {
    path: '/lawIssue',
    name: 'lawIssue',
    component: () => import('@/views/vipClip/vip/lawIssue.vue')
};
export const lawJudgement = {
    path: '/lawJudgement',
    name: 'lawJudgement',
    component: () => import('@/views/vipClip/vip/lawJudgement.vue')
};
export const lawService = {
    path: '/lawService',
    name: 'lawService',
    component: () => import('@/views/vipClip/vip/lawService.vue')
};
export const lawTelephone = {
    path: '/lawTelephone',
    name: 'lawTelephone',
    component: () => import('@/views/vipClip/vip/lawTelephone.vue')
};
//去登记
export const toReg = {
    path: '/toReg',
    name: 'toReg',
    component: () => import('@/views/toReg/toReg.vue')
};
//去登记
export const copyrightLogin = {
    path: '/copyrightLogin',
    name: 'copyrightLogin',
    component: () => import('@/views/toReg/copyrightLogin.vue')
};
//去预登记
export const preLogin = {
    path: '/preLogin',
    name: 'preLogin',
    component: () => import('@/views/vipClip/pre/preLogin.vue')
};
// 英文首页
export const english = {
    path: '/english',
    name: 'english',
    component: () => import('@/views/english/index.vue')
};
// 20220901
// 
export const goods = {
    path: '/goods',
    name: 'goods',
    component: () => import('@/views/vipClip/goods/goods.vue')
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    //redirect: '/home',
    component: () => import('@/views/Main.vue'),
    children: [
        {path: 'index.html', title: {i18n: 'home'}, name: 'home_index', component: () => import('@/views/vipClip/firstPage/firstPage.vue')},
        { path: '/instrument/:id', title: '法律服务', name: 'instrument', component: () => import('@/views/vipClip/firstPage/instrument.vue') },
        {
            path: 'ownspace',
            title: '个人中心',
            name: 'ownspace_index',
            component: () => import('@/views/own-space/own-space.vue')
        },
        {
            path: 'change-pass',
            title: '修改密码',
            name: 'change_pass',
            component: () => import('@/views/change-pass/change-pass.vue')
        },
        {path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/message/message.vue')},
        {
            path: 'add',
            title: '添加',
            name: 'add',
            component: () => import('@/views/xboot-vue-template/new-window/add.vue')
        },
        {
            path: 'edit',
            title: '编辑',
            name: 'edit',
            component: () => import('@/views/xboot-vue-template/new-window/edit.vue')
        },
        {
            path: 'message-send-detail',
            title: '消息发送详情',
            name: 'message_send_detail',
            component: () => import('@/views/sys/message-manage/messageSendDetail.vue')
        }
    ]
};
// 作为个人中心的组件展示右侧的路由
export const User = {
    path: '/',
    name: 'User',
    component: () => import('@/views/User.vue'),
    children: [
        {
            path: 'memberInfo',
            title: '会员信息',
            name: 'memberInfo',
            component: () => import('@/views/vipClip/user/personal/member-info.vue')
        },
        {
            path: 'myExisting',
            title: '我的存证',
            name: 'myCert',
            component: () => import('@/views/vipClip/user/service/myCert.vue')
        },
        {
            path: 'mycert_detail',
            title: '我的存证',
            name: 'myCertDetail',
            component: () => import('@/views/vipClip/user/service/mycert_detail.vue')
        },
        {
            path: 'myDci',
            title: '我的登记',
            name: 'myDci',
            component: () => import('@/views/vipClip/user/service/myDci.vue')
        },
        {
            path: 'myPre',
            title: '我的预登记',
            name: 'myPre',
            component: () => import('@/views/vipClip/pre/myPre.vue')
        },
        {
            path: 'myEvidence',
            title: '我的取证',
            name: 'myEvidence',
            component: () => import('@/views/vipClip/user/service/myEvidence.vue')
        },
        {
            path: 'myMonitor',
            title: '我的监测',
            name: 'myMonitor',
            component: () => import('@/views/vipClip/user/service/myMonitor.vue')
        },
        {
            path: 'walletPackage',
            title: '我的钱包',
            name: 'wallet',
            component: () => import('@/views/vipClip/user/personal/wallet.vue')
        },
        {
            path: 'membershipRights',
            title: '会员权益',
            name: 'membershipRights',
            component: () => import('@/views/vipClip/user/personal/membershipRights.vue')
        },
        {
            path: 'preRecharge',
            title: '预充值权益',
            name: 'preRcharge',
            component: () => import('@/views/vipClip/user/personal/preRcharge.vue')
        },
        {
            path: 'history',
            title: '登录历史',
            name: 'history',
            component: () => import('@/views/vipClip/user/more/history.vue')
        },
        {
            path: 'obligee',
            title: '权利人管理',
            name: 'obligee',
            component: () => import('@/views/vipClip/user/more/obligee/obligee.vue')
        },
        {
            path:'addObligee',
            title:'增加权利人',
            name:'addObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addObligee.vue')
        },
        {
            path:'addEnterpriseObligee',
            title:'增加企业权利人',
            name:'addEnterpriseObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addEnterpriseObligee.vue')
        },
        {
            path:'addPersonalObligee',
            title:'增加个人权利人',
            name:'addPersonalObligee',
            component: () => import('@/views/vipClip/user/more/obligee/addPersonalObligee.vue')
        },
        {
            path: 'legalOrder',
            title: '法律服务列表',
            name: 'legalOrder',
            component: () => import('@/views/vipClip/user/service/legal-order.vue')
        },
        {
            path: 'legalOrderDetails',
            title: '服务记录',
            name: 'legalOrderDetails',
            component: () => import('@/views/vipClip/user/service/legal-order-details.vue')
        },
        {
            path: 'messages',
            title: '消息通知',
            name: 'message',
            component: () => import('@/views/vipClip/user/more/message.vue')
        },
        {
            path: 'inviteFriend',
            title: '邀请有好礼',
            name: 'invite',
            component: () => import('@/views/vipClip/user/more/invite.vue')
        },
        {
            path:'authentication',
            title:'实名认证',
            name:'authentication',
            component: () => import('@/views/vipClip/user/more/authentication/authentication.vue')
        },
        {
            path:'personalAuthentication',
            title:'个人实名',
            name:'personalAuthentication',
            component: () => import('@/views/vipClip/user/more/authentication/personalAuthentication.vue')
        },
        {
            path:'enterpriseAuthentication1',
            title:'企业实名',
            name:'enterpriseAuthentication1',
            component: () => import('@/views/vipClip/user/more/authentication/enterpriseAuthentication1.vue')
        },
        {
            path:'enterpriseAuthentication2',
            title:'企业法人信息',
            name:'enterpriseAuthentication2',
            component: () => import('@/views/vipClip/user/more/authentication/enterpriseAuthentication2.vue')
        }


    ]
}

export const appRouter = [];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    loginRouter,
    registRouter,
    registResult,
    otherRouter,
    locking,
    ...appRouter,
    page500,
    page403,
    consultationList,
    consultationInfo,
    searchQuestion,
    certList,
    certInfo,
    evidenceList,
    evidenceInfo,
    copyrightEvidence,
    User,
    // vipOne,
    // vipTwo,
    vipSeven,
    lawContract,
    lawInfringing,
    lawIssue,
    lawJudgement,
    lawService,
    lawTelephone,
    evidence,
    evidenceWeb,
    monitor,
    monitorIntroduce,
    aboutUs,
    copyrightRegList,
    copyrightCert,
    copyrightDetails,
    preDetails,
    copyrightSuccess,
    applyCert,
    copyrightRegistration,
    creationVerification,
    monitoring,
    monitorDetails,
    verificationCode,
    contentListOriginal,
    verificationPublic,
    certVerify,
    dciIntroduce,
    lookMember,
    invitePage,
    thirdLogin,
    groupIntroduce,
    regEvidence,//存证登记
    toReg,//去登记
    copyrightLogin,//登记详情页
    preLogin,//预登记详情页
    english, // 英文首页
    goods,
];
